<nav class="vm-wizard {{ wizardClass }}"
     [ngClass]="wizardDynClass"
     [style]="wizardStyle">
  <div class="vm-wizard__wrapper">
    <input type="checkbox" id="wizard" class="vm-wizard-input" />
    <label class="vm-wizard-mobile" for="wizard">
      <ol class="vm-wizard-mobile__list">
        <li class="vm-wizard-mobile__item">
          <div class="vm-wizard__step">
            <span *ngIf="wizardActiveStep" class="vm-wizard__step__count">
              {{ wizardActiveStep }}
            </span>
            <span *ngIf="wizardActiveIcon"
                  class="material-symbols-outlined vm-icon vm-wizard__step__icon">{{ wizardActiveIcon }}</span>
            <img class="wizard-img-resp"
                 *ngIf="wizardActiveImage"
                 [src]="wizardActiveImage" />
          </div>
          <div class="vm-wizard__caption">{{ wizardActiveCaption }}</div>
        </li>
      </ol>
      <div class="material-symbols-outlined vm-icons">arrow_drop_down</div>
    </label>
    <ol #wizard class="vm-wizard__list" id="wizard">
      <ng-content select="[body]"></ng-content>
    </ol>
  </div>
</nav>
